module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 63
// module chunks = 0